import React from 'react';
import styles from './style.module.scss';

export default function Loader() {
  return <div className={styles.loader}></div>;
}
